import {Injectable} from '@angular/core';
import { OneDrive } from 'app/dms/onedrive/onedrive.service';
import {Observable, Subscriber} from 'rxjs';
import {IdexService} from '../idex.service';
import { DropBox } from 'app/dms/dropbox/dropbox.service';
import { MicrosoftIdTokenPayloadClaims } from '../dms/onedrive/onedrive.type';
import jwt_decode from "jwt-decode";

declare let FB: any;
declare const facebook: string;
declare var google: any;
declare var google_id: any;

@Injectable()
export class SocialLogin {
   facebookReady = false;
   googleReady = false;
   microsoftReady = false;
   dropboxReady = false;

   constructor(private onedrive: OneDrive, private service: IdexService,private dropbox: DropBox) {
      window['fbAsyncInit'] = this.initFacebook.bind(this);
      const lang = localStorage.getItem('lang') || 'en';
      window['___gcfg'] = {
         lang: lang === 'th' ? 'th-TH' : 'en-US'
      };
      this.facebookReady = this.loadScript('facebook', 'https://connect.facebook.net/' + (lang === 'th' ? 'th_TH' : 'en_US') + '/sdk.js');
      this.dropboxReady = this.loadScript('dropbox', 'https://www.dropbox.com/static/api/2/dropins.js');

      this.initMicrosoft();
   }

   private loadScript(id: string, src: string): boolean {
      if (document.getElementById(id)) {
         return true;
      }
      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      return false;
   }

   initFacebook(): void {
      FB.init({
         appId: facebook,
         cookie: true,
         xfbml: true,
         version: 'v20.0'
      });
      FB.AppEvents.logPageView();
      this.facebookReady = true;
   }

   initMicrosoft(): void {
      this.clearMicrosoft();
      this.microsoftReady = true;
   }

   withFacebook(): Observable<any> {
      const getProfile = (accessToken, observer) => {
         FB.api('/me?fields=first_name,last_name,email,id', response => {
            if (response.email) {
               observer.next({
                  accessToken: accessToken,
                  channel: 'facebook',
                  clientId: response.id,
                  email: response.email,
                  firstname: response.first_name,
                  lastname: response.last_name,
                  picture: 'https://graph.facebook.com/' + response.id + '/picture?type=normal'
               });
            } else {
               FB.logout();
               observer.error('Please grant access to your email address');
            }
         });
      };

      return new Observable<any>(observer => {
         FB.getLoginStatus(res1 => {
            if (res1.status === 'connected') {
               getProfile(res1.authResponse.accessToken, observer);
            } else {
               FB.login(res2 => {
                  if (res2.status === 'connected') {
                     getProfile(res2.authResponse.accessToken, observer);
                  }
               }, {scope: 'public_profile,email'});
            }
         });
      });
   }

   //migrate google
   withGoogle(): Observable<any> {
      const getToken = sessionStorage.getItem('token_google') as string;
      let profile: any;
      if (getToken) {
         profile = jwt_decode(getToken);
      }

      const getProfile = (observer) => {
         const getAccessToken = sessionStorage.getItem('access_token_google') as string;
         if (profile) {
            observer.next({
               accessToken: getAccessToken,
               channel: 'google',
               clientId: profile.sub,
               email: profile.email,
               firstname: profile.given_name,
               lastname: profile.family_name,
               picture: profile.picture
            });
         } else if (getAccessToken) {
            observer.next({
               accessToken: getAccessToken,
            });
         } else {
            observer.error('Please grant access to your email address');
         }
      };

      return new Observable<any>(observer => {
         if (profile) {
            getProfile(observer);
         } else {
            this.connectGoogle().subscribe(() => {
               getProfile(observer);
            });
         }
      });
   }

   connectGoogle() {
      const that = this;

      const gApi = new Observable (observe => {
         function handleCredentialResponse(response) {
            if (response.access_token) {
               sessionStorage.setItem('access_token_google', response.access_token);
               observe.next(response)
               observe.complete()
            }
         }

         setTimeout(() => {
            const client = google.accounts.oauth2.initTokenClient({
               client_id: google_id,
               callback: handleCredentialResponse,
               scope: that.service.SCOPE,
            });
            client.requestAccessToken()
         }, 0);
      });
      return gApi
   }

   withMicrosoft(): Observable<UserSocialAuthInfo> {
      this.clearMicrosoft();
      this.onedrive.signIn('signin');
      const getProfile = (idToken: string, accessToken: string, observer: Subscriber<UserSocialAuthInfo>) => {
         const profile = this.onedrive.getProfile(idToken) as MicrosoftIdTokenPayloadClaims;

         if (profile) {
            const name = profile.name.split(' ');
            localStorage.setItem('microsoft_domain', profile.email);
            observer.next({
               accessToken: accessToken,
               channel: 'microsoft',
               clientId: profile.oid,
               email: profile.email,
               firstname: profile.given_name,
               lastname: profile.family_name,
               picture: ''
            });
         } else {
            if (this.onedrive.isCallback()) {
               observer.error('Can not get user profile.');
            }
            this.clearMicrosoft();
         }
      };
      return new Observable<UserSocialAuthInfo>(observer => {
         const loop = setInterval(() =>  {
            if (!this.onedrive.waitCallback()) {
               clearInterval(loop);
               const accessToken = localStorage.getItem('access_token');
               const idToken = localStorage.getItem('id_token');
               getProfile(idToken, accessToken, observer);
            }
         }, 500);
      });
   }

   withDropBox(): Observable<any>{
      this.dropbox.clearDropBox();
      this.dropbox.signIn();
      const getProfile = (accessToken: any, observer: any) => {
         this.dropbox.getDropbox().subscribe(profile => {
            if (profile) {
               observer.next({
                  accessToken: accessToken,
                  userProfile: profile,
                  channel: 'dropbox',
               });
            } else {
               if (this.dropbox.isCallback()) {
                  observer.error('Please grant access app to your dropbox');
               }
               this.dropbox.clearDropBox();
            }
         });
      };
      return new Observable<any>(observer => {
         const loop = setInterval(() =>  {
            if (!this.dropbox.waitCallback()) {
               clearInterval(loop);
               const accessToken = localStorage.getItem('access_token_dropbox');
               getProfile(accessToken, observer);
            }
         }, 500);
      }) ;
   }

   withDropBoxPage(): Observable<any>{
      this.dropbox.clearDropBox();
      this.dropbox.signIn();
      const getProfile = (accessToken: any, observer: any) => {
         this.dropbox.getDropboxPage().subscribe(profile => {
            if (profile) {
               observer.next({
                  accessToken: accessToken,
                  userProfile: profile,
                  channel: 'dropbox',
               });
            } else {
               if (this.dropbox.isCallback()) {
                  observer.error('Please grant access app to your dropbox');
               }
               this.dropbox.clearDropBox();
            }
         })
      };
      return new Observable<any>(observer => {
         const loop = setInterval(() =>  {
            if (!this.dropbox.waitCallback()) {
               clearInterval(loop);
               const accessToken = localStorage.getItem('access_token_dropbox');
               getProfile(accessToken, observer);
            }
         }, 500);
      }) ;
   }

   private clearMicrosoft() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('onedrive_callback');
      localStorage.removeItem('onedrive_action');
   }
   private clearGoogle() {
      sessionStorage.removeItem('access_token_google');
   }
}

interface UserSocialAuthInfo {
   /** access token issued by auth provider API */
   accessToken: string,
   /** Name of the auth provider (Google, Microsoft, etc.) */
   channel: string,
   /** The client ID that auth provider API created for our application */
   clientId: string,
   /** User's email of the auth provider */
   email: string,
   firstname: string,
   lastname: string,
   /** profile picture URL */
   picture: string
}
